import Cookies from 'js-cookie'

export const handleAddonsPassword = {
  type: 'string',
  required: false,
}

export const handleAddonsUsername = {
  type: 'string',
  required: false,
}

export const useAddonsCredential = () => {
  const addonsPassword: string = Cookies.get('password_addons_v2')
  const addonsUsername: string = Cookies.get('username_addons_v2')

  return { addonsPassword, addonsUsername }
}

export const isConnectedToAddonsPS17 = () => {
  const buttonAddonsConnect: string = $(
    '#page-header-desc-configuration-addons_logout',
  )
    .text()
    .trim()
  const addonsEmail = buttonAddonsConnect.split(' ').at(-1) || ''

  const regexEmail = /^[\S]+@([\w-]+\.)+[\S-]{2,4}$/g

  return { isConnectedToAddonsPS17: regexEmail.test(addonsEmail) }
}

export const getAddonsPurchasedModules = async (token: string) => {
  const folderAdmin = window.location.pathname.split('/')[1]
  const url = `/${folderAdmin}/index.php/modules/addons/customer/modules?_token=${token}`

  const request = await fetch(url, {
    method: 'GET',
    mode: 'same-origin',
    cache: 'no-cache',
    redirect: 'error',
  })

  const res = await request.json()

  if (typeof res === 'string') return JSON.parse(res).modules
  else return []
}
